<template>
    <div class="container-exclusive-units-summary">
        <div class="title-summary">
            <em class="fal fa-users-class" />

            <span>Resumo</span>
        </div>

        <transition v-if="loading" name="small-fade">
            <div class="loading-card">
                <ui-load-indicator bgColor="#e7e9f4" color="#3FACFF" :h="50" :stroke="8" />
            </div>
        </transition>

        <div v-else>
            <div v-for="(summary, index) in summaryData" :key="index" class="content-summary">
                <div class="teams-quantity-units">
                    <span class="name-teams">
                        {{ summary.name }}
                    </span>

                    <span class="quantity-units">
                        {{ summary.units_count == 0 ? 'Nenhuma unidade selecionada' : summary.units_count == 1 ? `${summary.units_count} unidade` : `${summary.units_count} unidades` }}
                    </span>
                </div>

                <div class="value-total">
                    <span class="value">
                        {{ summary.total | currencyBRL }}
                    </span>
                </div>
            </div>
        </div>

        <div v-if="!loading && summaryData?.length === 0" class="has-summary">
            <span class="text-summary">
                Nenhum resumo encontrado.
            </span>
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui/'
import { currencyBRL } from "@/filters"
import { mapGetters } from 'vuex'

export default {
    name: 'ui-exclusive-units-summary',

    components: {
        uiLoadIndicator
    },

    filters: {
        currencyBRL
    },

    props: {},

    data() {
        return {
            summaryData: []
        }
    },

    computed: {
        ...mapGetters('exclusiveManagement', [
            'getData',
            'getLoadingList',
            'getConfigLimit'
        ]),

        loading() {
            return this.getLoadingList
        }
    },

    watch: {
        getConfigLimit: {
            deep: true,
            handler() {
                this.updateSummaryData()
            }
        },

        'getData.summary': {
            deep: true,
            handler() {
                this.summaryData = this.getData?.summary
            }
        }
    },

    mounted() {
        this.summaryData = this.getData?.summary
    },

    methods: {
        updateSummaryData() {
            if (!this.getConfigLimit?.data?.value?.units_exclusives) return

            const unitsExclusives = this.getConfigLimit.data.value.units_exclusives
            let updatedSummary = this.getData?.summary?.map(team => ({ ...team, units_count: 0, total: 0 })) || []

            unitsExclusives.forEach(({ unity_id, teams_id }) => {
                const unit = this.getData?.availability?.units.find(u => u.id === unity_id)
                if (!unit) return

                const unitValue = parseFloat(unit.cost)

                teams_id.forEach(teamId => {
                    let teamSummary = updatedSummary.find(t => t.id === teamId)

                    if (!teamSummary) {

                        let teamInfo = this.getData.filters.teams.find(t => t.id === teamId)
                        teamSummary = {
                            id: teamId,
                            name: teamInfo.name,
                            units_count: 0,
                            total: 0
                        }

                        updatedSummary.push(teamSummary)
                    }

                    teamSummary.units_count += 1
                    teamSummary.total = (parseFloat(teamSummary.total) + unitValue).toFixed(2)
                })
            })

            this.summaryData = updatedSummary
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>